import USER_ROLES from "../../../constants/userRoles.constants";

class UserListController {
    constructor($filter, $state, $mdDialog, userService) {
        this.$filter = $filter;
        this.$state = $state;
        this.$mdDialog = $mdDialog;
        this.userService = userService;
        this.me = this.userService.currentUser;
        this.users = [];
        this.searchText = '';

        this.selected = [];
        this.query = {
            order: '-id',
        };
        this.visibleRowsLimit = 20;
    }

    $onInit() {
        if(this.userService.isInRole(USER_ROLES.ROLE_ADMIN)) {
            this.getUsers();
        } else {
            this.$state.go('home');
        }
    }

    getUsers() {
        this.searchText = '';
        this.userService.fullList().then((res) => this.users = res)
            .catch(e => console.log('ERROR', e));
    }

    deleteUser(user) {
        this.$mdDialog.show(
            this.$mdDialog.confirm({
                title: 'Warning',
                textContent: 'Are you sure you want to delete this User?',
                ok: 'OK',
                cancel: 'Cancel',
                multiple: true,
            })
        ).then(() => {
            this.userService.delete(user.id).then(() => {
                this.getUsers();
            });
        }, () => false);
    };

    deactivateUser(user) {
        this.$mdDialog.show(
            this.$mdDialog.confirm({
                title: 'Warning',
                textContent: 'Are you sure you want to deactivate this User?',
                ok: 'OK',
                cancel: 'Cancel',
                multiple: true,
            })
        ).then(() => {
            user.isEnabled = false;
            this.userService.saveSmallProfile(user).then(() => {
                this.getUsers();
            });
        }, () => false);
    };

    activateUser(user) {
        this.$mdDialog.show(
            this.$mdDialog.confirm({
                title: 'Warning',
                textContent: 'Are you sure you want to activate this User?',
                ok: 'OK',
                cancel: 'Cancel',
                multiple: true,
            })
        ).then(() => {
            user.isEnabled = true;
            this.userService.saveSmallProfile(user).then(() => {
                this.getUsers();
            });
        }, () => false);
    };

    disableLimit(numberOfRecords) {
        this.visibleRowsLimit = numberOfRecords;
    }

    showMyProfile() {
        this.$state.go('user.profile', {id: this.me.id});
    }

    showMostImportantRole = (roles) => {
        if(roles.includes(USER_ROLES.ROLE_ADMIN)) {
            return 'Admin';
        } else if(roles.includes(USER_ROLES.ROLE_MANAGER)) {
            return 'Manager';
        }
        return 'Evaluator';
    };

    goToUser(userId) {
        this.$state.go('user.profile', { id: userId });
    }

    findUsers(searchText) {
        searchText = searchText ? searchText.trim() : '';
        if (searchText) {
            this.userService.list(searchText).then((res) => {
                this.users = res;
            }).catch(e => console.log('ERROR', e));
        } else {
            this.getUsers();
        }
    }
}

UserListController.$inject = [
    '$filter',
    '$state',
    '$mdDialog',
    'UserService',
];

export default UserListController;



// WEBPACK FOOTER //
// ./src/app/pages/user/list/userListController.js